"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/es/SvgIcon/SvgIcon"));
var CragheartIcon = /** @class */ (function (_super) {
    __extends(CragheartIcon, _super);
    function CragheartIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CragheartIcon.prototype.render = function () {
        return (react_1.default.createElement(SvgIcon_1.default, null,
            react_1.default.createElement("svg", null,
                react_1.default.createElement("path", { d: "m 7.3718762,18.005697 -1.0906499,-1.34676 1.2355299,-3.007248 c 0.67953,-1.653987 1.28597,-3.061135 1.34764,-3.126996 0.0952,-0.101689 3.6772898,2.207829 4.2261598,2.72479 0.15257,0.143696 -0.22453,0.689159 -2.16975,3.138448 -1.2949298,1.630488 -2.3777898,2.964524 -2.4063498,2.964524 -0.0286,0 -0.54273,-0.606041 -1.14258,-1.346758 z M 2.3676963,13.110698 C 0.44090634,10.331422 0.21644634,9.9502769 0.35684634,9.6962159 c 0.0869,-0.157291 0.64091,-0.807961 1.23107996,-1.445934 0.82462,-0.8914133 1.11601,-1.1269303 1.25867,-1.0173173 2.86204,2.1990013 4.3677799,3.3930004 4.3659899,3.4620774 -10e-4,0.04759 -0.6038399,1.314496 -1.3391199,2.815343 l -1.33688,2.728809 z M 12.768766,10.910212 c -1.13136,-0.871914 -2.13666,-1.6633741 -2.234,-1.7588001 -0.14403,-0.141208 0.0729,-0.691074 1.16564,-2.9542463 l 1.34262,-2.780745 2.15987,3.099955 c 1.18792,1.7049753 2.15986,3.1557003 2.15986,3.2238323 0,0.15244 -2.30518,2.7555891 -2.44002,2.7554231 -0.0533,-6.6e-5 -1.02262,-0.713505 -2.15397,-1.585419 z M 6.3920263,7.8195319 c -1.09365,-0.7543793 -2.03411,-1.4172153 -2.08992,-1.4729693 -0.0935,-0.09343 4.4555199,-5.95301596 4.6692399,-6.01441396 0.0521,-0.01498 0.57209,0.578805 1.1554498,1.31951796 l 1.06065,1.34675 -1.2663498,3.102541 c -0.6965,1.7063973 -1.32807,3.0997573 -1.40349,3.0963563 -0.0754,-0.0034 -1.03194,-0.623403 -2.1255799,-1.377782 z" }))));
    };
    return CragheartIcon;
}(react_1.Component));
exports.default = CragheartIcon;



//////////////////
// WEBPACK FOOTER
// ./src/components/icons/CragheartIcon.tsx
// module id = 787
// module chunks = 0